module.exports = __webpack_public_path__ + "media/images/athletes/57-d70254f5252b77b9234c282b796c1831.png";